export default __webpack_public_path__ + "static/media/risk-handling.f1ee6e04.svg";